/* eslint-disable */
import axios from "axios";

let _axios: any = null;

export default class Axios {
  static get Client() {
    _axios =
      _axios ||
      axios.create();
    return _axios;
  }
}

export const setRequestTypeHeader = (mode: string) => {
  Axios.Client.defaults.headers.common["type"] = mode;
};
